import { createContext, useContext } from 'react';
import { DEFAULT_PLAN_BUILDER_CONFIG, type PlanBuilderConfig } from './config';

export const PlanBuilderConfigContext = createContext<PlanBuilderConfig>(DEFAULT_PLAN_BUILDER_CONFIG);

export function usePlanBuilderConfigContext(): PlanBuilderConfig {
  return useContext(PlanBuilderConfigContext);
}
